var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHidePassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 112.718,
    viewBox: "0 0 150 112.718",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41359",
    "data-name": "Group 41359",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19834",
    "data-name": "Path 19834",
    d: "M188.51,321.083a103.257,103.257,0,0,1-31.284-30.645c-2.154-3.234-2.148-5.9.018-9.087,14.159-20.884,32.573-35.771,57.788-40.9a77.145,77.145,0,0,1,46.255,4.7c1.868.788,2.9.543,4.248-.871,4.051-4.243,8.258-8.342,12.423-12.477,2.655-2.637,5.328-2.966,7.447-.961,2.2,2.082,1.921,4.911-.823,7.655q-50.73,50.748-101.472,101.478c-.137.137-.275.28-.418.412-2.482,2.339-5.263,2.506-7.244.435-1.9-1.993-1.748-4.7.531-7.023,3.419-3.5,6.91-6.928,10.358-10.394C187.013,322.73,187.639,322.014,188.51,321.083Zm67.574-67.83a64.289,64.289,0,0,0-22.972-4.857c-28.9-.537-50,13.473-66.428,35.98a3.065,3.065,0,0,0-.155,2.781,89.431,89.431,0,0,0,28.706,26.683l11.957-11.987c-8.592-13.342-4.749-26.952,2.369-34.781a27.851,27.851,0,0,1,14.953-8.711,28.157,28.157,0,0,1,22.018,4.314Zm-16.737,16.3a18.152,18.152,0,0,0-22.674,3.687c-5.674,6.241-6.611,15.55-2.411,21.427Z",
    transform: "translate(-155.615 -229.547)",
    fill: "#674188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19835",
    "data-name": "Path 19835",
    d: "M231.065,240.949l6.82-6.969c3.1,2.763,6.45,5.215,9.117,8.258,5.084,5.794,9.8,11.9,14.613,17.924,1.874,2.339,1.844,4.743.161,7.291-14.893,22.531-34.59,38.074-61.87,42.514a77.822,77.822,0,0,1-33.7-2.112,20.464,20.464,0,0,1-2.017-.895c2.578-2.369,4.815-4.529,7.19-6.522a3.159,3.159,0,0,1,2.369-.471c32.811,6.874,61.178-10.424,78.022-34.631a3.6,3.6,0,0,0-.251-3.246,91.9,91.9,0,0,0-18.7-19.744C232.288,241.928,231.769,241.5,231.065,240.949Z",
    transform: "translate(-113.03 -207.53)",
    fill: "#674188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19836",
    "data-name": "Path 19836",
    d: "M201.162,237.7c5.561,21.433-13.443,40.413-34.214,34.751,4.254-3.109,6.247-7.9,11.934-9.058a16.464,16.464,0,0,0,13.139-12.775,15.858,15.858,0,0,1,4.857-7.989C198.268,241.291,199.42,239.722,201.162,237.7Z",
    transform: "translate(-99.326 -189.059)",
    fill: "#674188"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePassword);
export default __webpack_public_path__ + "static/media/HidePassword.c92e5ddf648c76ca0d6748e6fe50f02a.svg";
export { ForwardRef as ReactComponent };